import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "15.001",
      r: "15",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15 0C6.72905 0 0 6.72886 0 14.9999C0 23.271 6.72905 30 15 30C23.271 30 30 23.271 30 14.9999C30 6.72886 23.2711 0 15 0ZM23.6133 12.4663L14.1895 21.89C13.7888 22.2907 13.2562 22.5112 12.6896 22.5112C12.123 22.5112 11.5903 22.2907 11.1896 21.89L6.38674 17.0871C5.98604 16.6864 5.76534 16.1538 5.76534 15.5872C5.76534 15.0204 5.98604 14.4878 6.38674 14.0871C6.78728 13.6864 7.31992 13.4657 7.88669 13.4657C8.4533 13.4657 8.9861 13.6864 9.38664 14.0872L12.6894 17.3898L16.6512 13.4281L20.613 9.46626C21.0137 9.06557 21.5464 8.84503 22.113 8.84503C22.6796 8.84503 23.2123 9.06557 23.613 9.46626C24.4403 10.2936 24.4403 11.6392 23.6133 12.4663Z",
      fill: "#FFA800"
    }, null, -1)
  ])))
}
export default { render: render }